import { render, staticRenderFns } from "./detalhe-protocolo.vue?vue&type=template&id=41cba6a2"
import script from "./detalhe-protocolo.vue?vue&type=script&lang=js"
export * from "./detalhe-protocolo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports